import reqNotaFiscal from "../../../services/reqCobranca/reqNotaFiscal";
import functions from "../../../util/functions";
import { erroDaSefaz, salvarXml } from "./documentos";

export async function listarChavesSefaz(f) {
	try {
		const { data } = await reqNotaFiscal.chavesSefaz({
			dtini: functions.dateByString(f.dtIni),
			dtfim: functions.dateByString(f.dtFim),
		});
		return data;
	} catch (erro) {
		throw erroDaSefaz(erro);
	}
}

export async function baixarXmlSefaz(chave) {
	try {
		const { data } = await reqNotaFiscal.xmlSefaz(chave);
		salvarXml(data.xml, `${chave}-sefaz.xml`);
		return data.situacao;
	} catch (erro) {
		throw erroDaSefaz(erro);
	}
}
